import { render, staticRenderFns } from "./bindings.vue?vue&type=template&id=09b0e584&scoped=true"
import script from "./bindings.vue?vue&type=script&lang=js"
export * from "./bindings.vue?vue&type=script&lang=js"
import style0 from "./bindings.vue?vue&type=style&index=0&id=09b0e584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b0e584",
  null
  
)

export default component.exports